import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'
import networkWrapper from '../utils/networkWrapper'

import apiUtils from '../api'
import userActions from './user'
import projectActions from './project'
import quoteActions from './quote'

import userSelectors from '../selectors/user'

const prefix = 'system'

const initialState = {
  loaded: false,
}

const reducers = {
  setLoaded: (state, action) => {
    state.loaded = action.payload
  },
}

const sideEffects = {

  initialize: () => networkWrapper({
    prefix,
    name: 'initialize',
    handler: async (dispatch, getState) => {
      const urlParams = new URLSearchParams(window.location.search)
      const token = urlParams.get('token')
      const project = urlParams.get('project')
      if(token) {
        apiUtils.setToken(token)
      }
      if(project) {
        dispatch(projectActions.setQueryProjectId(project))
      }
      await dispatch(userActions.loadStatus())
      const user = userSelectors.data(getState())
      if(user) {
        await dispatch(projectActions.list())
        await dispatch(userActions.loadToken())
      }
      dispatch(actions.setLoaded(true))
    },
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export {
  actions,
  reducer,
}

export default actions